import React from "react";
import LayoutPagePublications from "@/layout/pages/publications";
import { CATEGORIES } from "@/configs/categories";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { Viewport } from "@/types/enum";
import { Categorie } from "@/types/categorie";
import { PagedItems } from "@/types/contenu";
import { SERVER_SIDE_CACHE_HEADER } from "@/configs/cache";

type ArticlePlanifierProps = {
    data: Categorie[];
    viewport: Viewport;
};

const ArticlesPlanifier = ({ data, viewport }: ArticlePlanifierProps) => (
    <LayoutPagePublications
        contenu={data}
        viewport={viewport}
        boutonTitle="Voir tous les articles"
        parentId={CATEGORIES.PLANIFIER}
        title="Planifier"
    />
);

export const getServerSideProps = (async ({ res, query }: GetServerSidePropsContext) => {
    const api = process.env.SERVER_API_URL;

    res.setHeader("Cache-Control", SERVER_SIDE_CACHE_HEADER);

    const response = await fetch(`${api}/v1/categories/type/publication`);
    const viewport = query["viewport"] || "desktop";

    const json: PagedItems<Categorie> = await response.json();

    return {
        props: {
            data: json.items,
            viewport: viewport,
        },
    };
}) satisfies GetServerSideProps;

export default ArticlesPlanifier;
